<template>
    <div class="sites-counter" :class="{'is-exceeded': isExceeded, 'is-lifetime': 'lifetime' === license.type}">
        <template v-if=" 'lifetime' !== license.type">
            <p>Active sites in your plan:</p>
            <div class="counter">
                <span class="active">{{ license.used_seats }}</span>/<span class="all">{{ license.seats }}</span>
            </div>
            <router-link
                v-if="show"
                to="/settings/sites"
            >
                    Manage Sites
            </router-link>
        </template>
        <template v-else>
            <p>Your Plan:</p>
            <span class="plan-name">Fusebox Lifetime</span>
            <span class="plan-sites">({{ sites }})</span>
        </template>
    </div>
</template>

<script>

export default {
    props: {
        license: {
            type: Object,
            default: () => {},
        },
    },

    data: () => ({
        show: false,
    }),

    computed: {
        /**
         * @returns {boolean} Whether the license seats number is exceeded.
         */
        isExceeded() {
            return this.license && this.license.used_seats > this.license.seats;
        },

        /**
         * @returns {string} Sites count
         */
        sites() {
            return 1 === this.license.seats ? `${this.license.seats} site` : `${this.license.seats} sites`;
        },
    },

    /**
     * Created hook
     */
    created() {
        if ('/tools' === this.$route.path) {
            this.show = true;
        }
    },
};
</script>
